import { Page } from "@/models/page-models/Page";

export const StatementOfBalance: Page = {
  "path": "statement-of-balance",
  "name": "Statement Of Balance ",
  "props": {
    "data": {
      "title": "Statement Of Balance ",
      "printable": "TRUE",
      "url": "statement-of-balance",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})",
                  "printable": false
                },
                {
                  "type": "dropdown",
                  "variable": "formData.dueStatus",
                  "label": "Collection Status",
                  "disabled": "FALSE",
                  "items": "[\"Overdue\",\"Due Soon\",\"Not Due\"]",
                  "dropdownType": "static",
                  "printable": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Statement",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToStatement",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/statement-of-balance",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{formData.customer}}\",\"dueStatus\":\"{{formData.dueStatus}}\"}"
                      },
                      "name": "redirectToStatement"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                },
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.balanceStatement}}",
                  "color": "secondary",
                  "buttonType": "print"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_CustomerStatementDetails",
                  "variable": "fetchedData.selectedCustomer",
                  "label": "Customer Statement Details",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.balanceStatement}}",
                  "config": {
                    "type": "balance"
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Statement Of Balance",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.balanceStatement}}",
                  "items": "fetchedData.balanceStatement.data.fullReport",
                  "headers": [
                    {
                      "value": "__item.date",
                      "text": "Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.date}})"
                    },
                    {
                      "value": "type",
                      "text": "Type",
                      "formula": "fn(HELPER_FN,salesDocType,{{__item}})"
                    },
                    {
                      "value": "__item._id",
                      "text": "Doc #",
                      "type": "url",
                      "formula": "fn(CONDITIONAL,{{'{{__item.type}}'=='Credit Note'}},\n{{__item.typeId}},\nfn(CONDITIONAL,{{'{{__item.type}}'=='invoice'}},{{__item._id}},{{__item.invoicePaymentReceipt}}))",
                      "url": "fn(CONDITIONAL,{{'{{__item.type}}'=='invoice'}},/invoice/{{__item._id}},fn(CONDITIONAL,{{'{{__item.type}}'=='Credit Note'}},/credit-note/{{__item._id}},/invoice-payment-receipt/{{__item.invoicePaymentReceipt}}))"
                    },
                    {
                      "value": "__item.description",
                      "text": "Description",
                      "formula": "fn(HELPER_FN,statementDescription,{{__item}})"
                    },
                    {
                      "value": "__item.amount",
                      "text": "Amount\\nالمبلغ",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.amount}})"
                    },
                    {
                      "value": "__item.endBalance",
                      "text": "Balance\\nالرصيد",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.remainingBalance}})"
                    },
                    {
                      "value": "__item.dueDate",
                      "text": "Due Date\\nتاريخ الاستحقاق",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.dueDate}})"
                    },
                    {
                      "value": "__item.dueStatus",
                      "text": "Collection Status"
                    }
                  ],
                  "tableType": "static",
                  "fontSize": "0.75rem",
                  "enableGoogleSheetExport": true,
                  "googlSheetFileName": "Statement Of Balance {{fetchedData.selectedCustomer.alias}}"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Sales | Manager),||,fn(MATCH_ROLE,Customer Service | Manager))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showMisc=true&showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getAllCustomers",
        "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),||,fn(MATCH_ROLE,General Manager))"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyQueryParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getQueryParams",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyQueryParams"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getBalanceStatement",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/invoice/statement-of-balance-report/{{formData.customer}}?dueStatus={{formData.dueStatus}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.balanceStatement"
        },
        "name": "getBalanceStatement",
        "executeIf": "fn(LOGICAL,{{formData.customer}},>,0)"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copySelectedCustomer",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "findSelectedCustomer",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.selectedCustomer"
        },
        "name": "copySelectedCustomer"
      }
    ],
    "functions": [
      {
        "name": "getQueryParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "fn(NUMBER,{{__query.customer}})",
          "dueStatus": "{{__query.dueStatus}}"
        },
        "useFormula": true
      },
      {
        "name": "findSelectedCustomer",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.customers.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "formData.customer"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,CUSTOMER_SERVICE_MANAGER,GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 60
}